import ApiService from './api'
import { calendarReviewRequest } from './calendarReviewRequest'

const SYNC_TIMEOUT_MS = Number(import.meta.env.VITE_CALENDAR_SYNC_TIMEOUT_MS || 180000)

function queryString(values = {}) {
  const params = new URLSearchParams()
  Object.entries(values).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') params.set(key, String(value))
  })
  const result = params.toString()
  return result ? `?${result}` : ''
}

const DeadlineCalendarApi = {
  listSources(options = {}) {
    return ApiService.request('deadline-engine/v1/admin/calendars/sources', options)
  },

  syncSource(sourceKey, year, options = {}) {
    return ApiService.request(
      `deadline-engine/v1/admin/calendars/sources/${encodeURIComponent(sourceKey)}/sync${queryString({ year })}`,
      { ...options, method: 'POST', timeoutMs: SYNC_TIMEOUT_MS },
    )
  },

  listEvents(filters = {}, options = {}) {
    return ApiService.request(`deadline-engine/v1/admin/calendars/events${queryString(filters)}`, options)
  },

  listRuns(filters = {}, options = {}) {
    return ApiService.request(`deadline-engine/v1/admin/calendars/runs${queryString(filters)}`, options)
  },

  reviewEvent(eventId, approved, reason = null, reviewVersion, options = {}) {
    return ApiService.request(`deadline-engine/v1/admin/calendars/events/${eventId}/review`, {
      ...options,
      method: 'POST',
      body: JSON.stringify(calendarReviewRequest(reviewVersion, approved, reason)),
    })
  },
}

export default DeadlineCalendarApi
